"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.resultMessages = exports.Result = void 0;
const schema_1 = require("../../../../schema");
var Result;
(function (Result) {
    Result["CANNOT_BE_PLACED_ON_LIST"] = "CANNOT_BE_PLACED_ON_LIST";
    Result["CAN_BE_PLACED_ON_LIST"] = "CAN_BE_PLACED_ON_LIST";
})(Result || (exports.Result = Result = {}));
exports.resultMessages = {
    [Result.CANNOT_BE_PLACED_ON_LIST]: {
        id: "ktx.transplantationScreening.cardiology.cardiologyOpinion.result.CANNOT_BE_PLACED_ON_LIST",
        defaultMessage: "Nem helyezhető listára"
    },
    [Result.CAN_BE_PLACED_ON_LIST]: {
        id: "ktx.transplantationScreening.cardiology.cardiologyOpinion.result.CAN_BE_PLACED_ON_LIST",
        defaultMessage: "Listára helyezhető"
    }
};
const result = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Result.CANNOT_BE_PLACED_ON_LIST),
    schema_1.Schema.singleChoiceItem(Result.CAN_BE_PLACED_ON_LIST)
]);
const description = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ result, description })
    .interpretation({ vocab: "ktx", code: "cardiology_opinion" })
    .tag({ vocab: "ktx", code: "consultation procedure" });
